import cacheModule from '@/store/modules/cache.module'
import equals from 'ramda/src/equals'

class CacheUtils {
  findCache(path, params) {
    const caches = cacheModule.getCaches(path) || []
    const cache = caches.find(({ params: cachedParams }) => equals(cachedParams, params))
    return cache?.data || false
  }
}

export default new CacheUtils()
